module.exports = __webpack_public_path__ + "img/section2Bg3.7c1251fe.webp";